import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

interface BannerProps {
    subtitle?: string;
    title: string;
    desc: string;
    children: JSX.Element[] | JSX.Element | boolean;
    isInner?: boolean;
}

const Banner: FC<BannerProps> = ({ subtitle, title, desc, children, isInner = true }) => {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();

    const pcImg =
        locale === 'au'
            ? 'https://websiteoss.ecoflow.com/upload/image/1733225130462/referral-au.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1733225108715/referral.jpg';
    const h5Img =
        locale === 'au'
            ? 'https://websiteoss.ecoflow.com/upload/image/1733225255764/referral-aumobile.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1733225242405/referral-mobile.jpg';

    return (
        <div id="referral-banner" className={`${styled.banner}`}>
            <EditorImg pc={pcImg} h5={h5Img} alt={title} aria-label={title} />
            <div className="banner_text">
                {isInner && (
                    <div className="content">
                        {subtitle && <p className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}></p>}
                        <h1 className="title" dangerouslySetInnerHTML={{ __html: title }}></h1>
                        <p className="desc" dangerouslySetInnerHTML={{ __html: desc }}></p>
                        <div className="tools">{children && children}</div>
                    </div>
                )}
                {!isInner && (
                    <div className="content">
                        {subtitle && <p className="subtitle">{subtitle}</p>}
                        <h1 className="title">{title}</h1>
                        <p className="desc">{desc}</p>
                        <div className="tools">{children && children}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Banner;
